import React, { FC } from 'react';
import { ReactComponent as ThisWeekSvg } from 'assets/svgs/this-week.svg';
import { ClassNameOnlyProps } from 'components/ozone-component';

const ThisWeek: (size: number) => FC<ClassNameOnlyProps> =
  (size) =>
  ({ className }) =>
    (
      <ThisWeekSvg
        fill="currentColor"
        className={className}
        width={size}
        height={size}
      />
    );

export const ThisWeek16 = ThisWeek(16);
export const ThisWeek20 = ThisWeek(20);
export const ThisWeek24 = ThisWeek(24);
export const ThisWeek32 = ThisWeek(32);
